<div class="stock-item-rule-disable-container no-select">

  <div class="widget-div">

    @if (canDisableItemRuleBeViewed) {
      <app-shared-widget-container-component>
        <div title class="widget-div-heading">
          <app-display-icon
            [tooltip]="canDisableItemRuleBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"
            [icon]="canDisableItemRuleBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">
          </app-display-icon>
          <div>When On Hand Not Zero</div>
          <app-display-icon
            [tooltip]="tooltips.disableStockItemNotOnHand"
            [icon]="icons.infoSlabCircleOutline"
            [colour]="iconColours.secondary">
          </app-display-icon>
        </div>
        <div block>
          <form [formGroup]="formDisableItemRule">

            @if (formDisableItemRule?.controls['onHandNotZeroDescPrefix']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="onHandNotZeroDescPrefix">Description Prefix</label>
                  <input
                    [class.invalid]="formDisableItemRule?.controls['onHandNotZeroDescPrefix']?.errors"
                    [formControlName]="'onHandNotZeroDescPrefix'"
                    [placeholder]="'Enter description prefix'"
                    id="onHandNotZeroDescPrefix"
                    type="text"/>
                </div>
              </div>
            }

            @if (formDisableItemRule?.controls['onHandNotZeroDescSuffix']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="onHandNotZeroDescSuffix">Description Suffix</label>
                  <input
                    [class.invalid]="formDisableItemRule?.controls['onHandNotZeroDescSuffix']?.errors"
                    [formControlName]="'onHandNotZeroDescSuffix'"
                    [placeholder]="'Enter description suffix'"
                    id="onHandNotZeroDescSuffix"
                    type="text"/>
                </div>
              </div>
            }

            @if (formDisableItemRule?.controls['onHandNotZeroLineColour']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="onHandNotZeroLineColour">Line Colour</label>
                  <app-shared-custom-select
                    id="onHandNotZeroLineColour"
                    (selectionChange)="onLineColourChange($event, 'onHandNotZeroLineColour')"
                    [allowMultiple]="false"
                    [allowSelectAll]="false"
                    [autoSubmitOnSelect]="true"
                    [floatDropdown]="true"
                    [placeholder]="'Select line colour...'"
                    [selected]="['lc-' + formDisableItemRule?.controls['onHandNotZeroLineColour']?.value?.toString()]"
                    [setOptions]="getLineColourOptions(formDisableItemRule?.controls['onHandNotZeroLineColour']?.value)"
                    [showActionButtons]="false"
                    [showChips]="false">
                  </app-shared-custom-select>
                </div>
              </div>
            }

            @if (formDisableItemRule?.controls['onHandNotZeroOnHoldCode']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="onHandNotZeroOnHoldCode">On Hold Code</label>
                  <app-shared-custom-select
                    id="onHandNotZeroOnHoldCode"
                    (selectionChange)="onOnHoldCodeChange($event, 'onHandNotZeroOnHoldCode')"
                    [allowMultiple]="true"
                    [allowSelectAll]="true"
                    [floatDropdown]="true"
                    [placeholder]="'Select on hold codes...'"
                    [searchPlaceholder]="'Search on hold codes...'"
                    [selected]="onHandNotZeroOnHoldCodeSelected()"
                    [setOptions]="getOnHoldCodeOptions(onHandNotZeroOnHoldCodeSelected())"
                    [showChips]="false"
                    [showSearchBar]="true">
                  </app-shared-custom-select>
                </div>
              </div>
            }

            @if (formDisableItemRule?.controls['onHandNotZeroSupplierAction']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="onHandNotZeroSupplierAction">Regular Supplier</label>
                  <app-shared-custom-select
                    id="onHandNotZeroSupplierAction"
                    (selectionChange)="onSupplierActionChange($event, 'onHandNotZeroSupplierAction')"
                    [allowMultiple]="false"
                    [allowSelectAll]="false"
                    [autoSubmitOnSelect]="true"
                    [floatDropdown]="true"
                    [placeholder]="'Select supplier action...'"
                    [selected]="onHandNotZeroSupplierActionSelected()"
                    [setOptions]="onHandNotZeroSupplierActionOptions()"
                    [showActionButtons]="false"
                    [showChips]="false"
                    [showSearchBar]="false">
                  </app-shared-custom-select>
                </div>
              </div>
            }

            @if (formDisableItemRule?.controls['onHandNotZeroRegularSuppCode'] && onHandNotZeroSupplierActionSelected()[0] === supplierActionEnum.set) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="onHandNotZeroRegularSuppCode">Supplier</label>
                  <app-shared-custom-select
                    id="onHandNotZeroRegularSuppCode"
                    (selectionChange)="onRegularSuppCodeChange($event, 'onHandNotZeroRegularSuppCode')"
                    [allowMultiple]="false"
                    [allowSelectAll]="false"
                    [autoSubmitOnSelect]="true"
                    [class.invalid]="!!formDisableItemRule?.controls['onHandNotZeroRegularSuppCode']?.errors && (formDisableItemRule?.controls['onHandNotZeroRegularSuppCode']?.dirty || formDisableItemRule?.controls['onHandNotZeroRegularSuppCode']?.touched)"
                    [floatDropdown]="true"
                    [placeholder]="'Select supplier...'"
                    [searchPlaceholder]="'Search suppliers...'"
                    [selected]="onHandNotZeroRegularSuppCodeSelected()"
                    [setOptions]="onHandNotZeroSupplierOptions()"
                    [showActionButtons]="false"
                    [showChips]="false"
                    [showSearchBar]="true">
                  </app-shared-custom-select>
                </div>
              </div>
            }

          </form>
        </div>
        <div actions class="widget-actions">
          @if (hasDisableItemRuleBeenEdited) {
            <button
              type="button"
              class="action-button"
              [disabled]="canDisableItemRuleBeEdited === false"
              (click)="onRevertForm('disableItemRule')">
              <app-display-icon
                [colour]="canDisableItemRuleBeEdited === false ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.undoChanges"
                [icon]="icons.undo">
              </app-display-icon>
            </button>
          }
          @if (canDisableItemRuleBeSubmitted) {
            <button
              type="button"
              class="action-button"
              [disabled]="isDisableItemRuleSubmitDisabled"
              (click)="onSubmitForm('disableItemRule')">
              <app-display-icon
                [colour]="isDisableItemRuleSubmitDisabled ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.saveChanges"
                [icon]="icons.contentSaveOutline">
              </app-display-icon>
            </button>
          }
        </div>
      </app-shared-widget-container-component>

      <app-shared-widget-container-component>
        <div title class="widget-div-heading">
          <app-display-icon
            [tooltip]="canDisableItemRuleBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"
            [icon]="canDisableItemRuleBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">
          </app-display-icon>
          <div>When On Hand Zero</div>
          <app-display-icon
            [tooltip]="tooltips.disableStockItemOnHand"
            [icon]="icons.infoSlabCircleOutline"
            [colour]="iconColours.secondary">
          </app-display-icon>
        </div>
        <div block>
          <form [formGroup]="formDisableItemRule">

            @if (formDisableItemRule?.controls['onHandZeroDescPrefix']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="onHandZeroDescPrefix">Description Prefix</label>
                  <input
                    [class.invalid]="formDisableItemRule?.controls['onHandZeroDescPrefix']?.errors"
                    [formControlName]="'onHandZeroDescPrefix'"
                    [placeholder]="'Enter description prefix'"
                    id="onHandZeroDescPrefix"
                    type="text"/>
                </div>
              </div>
            }

            @if (formDisableItemRule?.controls['onHandZeroDescSuffix']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="onHandZeroDescSuffix">Description Suffix</label>
                  <input
                    [class.invalid]="formDisableItemRule?.controls['onHandZeroDescSuffix']?.errors"
                    [formControlName]="'onHandZeroDescSuffix'"
                    [placeholder]="'Enter description suffix'"
                    id="onHandZeroDescSuffix"
                    type="text"/>
                </div>
              </div>
            }

            @if (formDisableItemRule?.controls['onHandZeroLineColour']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="onHandZeroLineColour">Line Colour</label>
                  <app-shared-custom-select
                    id="onHandZeroLineColour"
                    (selectionChange)="onLineColourChange($event, 'onHandZeroLineColour')"
                    [allowMultiple]="false"
                    [allowSelectAll]="false"
                    [autoSubmitOnSelect]="true"
                    [floatDropdown]="true"
                    [placeholder]="'Select line colour...'"
                    [selected]="['lc-' + formDisableItemRule?.controls['onHandZeroLineColour']?.value?.toString()]"
                    [setOptions]="getLineColourOptions(formDisableItemRule?.controls['onHandZeroLineColour']?.value)"
                    [showActionButtons]="false"
                    [showChips]="false">
                  </app-shared-custom-select>
                </div>
              </div>
            }

            @if (formDisableItemRule?.controls['onHandZeroOnHoldCode']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="onHandZeroOnHoldCode">On Hold Code</label>
                  <app-shared-custom-select
                    id="onHandZeroOnHoldCode"
                    (selectionChange)="onOnHoldCodeChange($event, 'onHandZeroOnHoldCode')"
                    [allowMultiple]="true"
                    [allowSelectAll]="true"
                    [floatDropdown]="true"
                    [placeholder]="'Select on hold codes...'"
                    [searchPlaceholder]="'Search on hold codes...'"
                    [selected]="onHandZeroOnHoldCodeSelected()"
                    [setOptions]="getOnHoldCodeOptions(onHandZeroOnHoldCodeSelected())"
                    [showChips]="false"
                    [showSearchBar]="true">
                  </app-shared-custom-select>
                </div>
              </div>
            }

            @if (formDisableItemRule?.controls['onHandZeroSupplierAction']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="onHandZeroSupplierAction">Regular Supplier</label>
                  <app-shared-custom-select
                    id="onHandZeroSupplierAction"
                    (selectionChange)="onSupplierActionChange($event, 'onHandZeroSupplierAction')"
                    [allowMultiple]="false"
                    [allowSelectAll]="false"
                    [autoSubmitOnSelect]="true"
                    [floatDropdown]="true"
                    [placeholder]="'Select supplier action...'"
                    [selected]="onHandZeroSupplierActionSelected()"
                    [setOptions]="onHandZeroSupplierActionOptions()"
                    [showActionButtons]="false"
                    [showChips]="false"
                    [showSearchBar]="false">
                  </app-shared-custom-select>
                </div>
              </div>
            }

            @if (formDisableItemRule?.controls['onHandZeroRegularSuppCode'] && onHandZeroSupplierActionSelected()[0] === supplierActionEnum.set) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="onHandZeroRegularSuppCode">Supplier</label>
                  <app-shared-custom-select
                    id="onHandZeroRegularSuppCode"
                    (selectionChange)="onRegularSuppCodeChange($event, 'onHandZeroRegularSuppCode')"
                    [allowMultiple]="false"
                    [allowSelectAll]="false"
                    [autoSubmitOnSelect]="true"
                    [class.invalid]="!!formDisableItemRule?.controls['onHandZeroRegularSuppCode']?.errors && (formDisableItemRule?.controls['onHandZeroRegularSuppCode']?.dirty || formDisableItemRule?.controls['onHandZeroRegularSuppCode']?.touched)"
                    [floatDropdown]="true"
                    [placeholder]="'Select supplier...'"
                    [searchPlaceholder]="'Search suppliers...'"
                    [selected]="onHandZeroRegularSuppCodeSelected()"
                    [setOptions]="onHandZeroSupplierOptions()"
                    [showActionButtons]="false"
                    [showChips]="false"
                    [showSearchBar]="true">
                  </app-shared-custom-select>
                </div>
              </div>
            }

          </form>
        </div>
        <div actions class="widget-actions">
          @if (hasDisableItemRuleBeenEdited) {
            <button
              type="button"
              class="action-button"
              [disabled]="canDisableItemRuleBeEdited === false"
              (click)="onRevertForm('disableItemRule')">
              <app-display-icon
                [colour]="canDisableItemRuleBeEdited === false ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.undoChanges"
                [icon]="icons.undo">
              </app-display-icon>
            </button>
          }
          @if (canDisableItemRuleBeSubmitted) {
            <button
              type="button"
              class="action-button"
              [disabled]="isDisableItemRuleSubmitDisabled"
              (click)="onSubmitForm('disableItemRule')">
              <app-display-icon
                [colour]="isDisableItemRuleSubmitDisabled ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.saveChanges"
                [icon]="icons.contentSaveOutline">
              </app-display-icon>
            </button>
          }
        </div>
      </app-shared-widget-container-component>
    }

  </div>

  <div class="ups-container-action-bar widget-actions">
    @if (hasDisableItemRuleErrors?.length > 0) {
      @for (field of hasDisableItemRuleErrors; track $index) {
        <button
          type="button"
          class="error-button">
          <app-display-icon
            [colour]="iconColours.red"
            [tooltip]="field?.error"
            [icon]="icons.alertRhombusOutline">
          </app-display-icon>
        </button>
      }
    }
      <button
        [disabled]="!haveAnyEditsBeenMade"
        type="button"
        class="action-button"
        (click)="onRevertForm('all')">
        <app-display-icon
          [colour]="iconColours.secondary"
          [tooltip]="tooltips.undoAllChanges"
          [icon]="icons.undo">
        </app-display-icon>
        Undo Changes
      </button>
      <button
        [disabled]="isSaveAllDisabled"
        type="button"
        class="action-button"
        (click)="onSubmitForm('all')">
        <app-display-icon
          [colour]="isSaveAllDisabled ? iconColours.disabled : iconColours.secondary"
          [tooltip]="tooltips.saveAllChanges"
          [icon]="icons.contentSaveOutline">
        </app-display-icon>
        Save All
      </button>
  </div>

</div>
